export function ThresholdField({
  draft,
  onDraft,
  onCommit,
}: {
  draft: string
  onDraft: (value: string) => void
  onCommit: () => void
}) {
  return (
    <label className="flex items-center gap-2 text-sm text-gray-700">
      Schwelle
      <input
        type="number"
        min={1}
        aria-label="Schwelle"
        value={draft}
        onChange={(event) => onDraft(event.target.value)}
        onBlur={onCommit}
        className="w-20 px-3 py-2 border rounded-lg text-sm"
      />
    </label>
  )
}
